<template>
    <div class="s-input">
        
        <!--<b-form-input 
            :class="myClass" 
            :id="id" 
            :name="name" 
            :autocomplete="autocomplete"
            :type="type" 
            :maxlength="maxlength" 
            :placeholder="placeholder" 
            v-model="displayValue"
            :trim="true">
        </b-form-input>-->

        <div class="text-field">
            <!--<b-form-input type="text" required></b-form-input>-->
            <b-form-input 
                :class="myClass" 
                :id="id" 
                :name="name" 
                :disabled="disabled"
                autocomplete= "off"
                :type="type" 
                :maxlength="maxlength" 
                v-model="displayValue"
                :trim="true"
                :state="state"
                :readonly="readonly">
            </b-form-input>
            <label>{{placeholder}}</label>
        </div>

    </div>
</template>

<script>

//import {mapGetters} from 'vuex'

export default{
    name: "s-input",
    props: ['value', 'myClass', 'id', 'name','disabled','autocomplete', 'type', 'maxlength','placeholder','state','readonly'],
    data: function() {
        return {
            
        }
    },
    methods:{

    },
    computed: {
        //...mapGetters(['getAllSize']),
        displayValue: {
            get: function() {
                let sendValue = this.value
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('input', newValue)
            }
        }
    }
}


</script>

<style lang="scss" scoped>

.text-field {
        position: relative;
        margin: 10px 0px 0px 0px;
    }

input {
        display: inline-block;
        height: 40px;
        border: solid thin $ServexGray;
        //border-top: solid 1px $ServexBlue;
        color: $ServexBlue;
        background-color: $ServexMainColorOpposite;
        padding: 20px 10px 10px 10px;
       //border-radius: $sBorderRadius;
        box-shadow: 0.2px 0.2px 0.2px 0.2px transparent
    }

    input:focus {
            background-color: $ServexMainColorOpposite;
            outline: none;
            //box-shadow: 0.2px 0.2px 0.2px 0.2px $ServexShadow;
            box-shadow: 0px 0px 0.5px 0.5px $MainColor;
        }

label {
        font-size: smaller; //small;
        position: absolute;
        pointer-events: none;
        top: 1px;
        left: 5px;
        color: $MainColor; //$ServexBlue;
        background-color:transparent;
        padding:0 5px 0 5px;
        transition: 0.2s;
        border-radius: 10px;
    }

input:focus ~ label {
        //font-size: 10px; //small;
        color: $ServexLightGray; //$MainColor; //$ServexBlue;
        border-radius: 10px;
        //padding:0 15px 0 15px;
    }

//input:valid ~ label {
//        top: -10px;
//        left: 15px;
//        font-size: small;
//        color: yellow;
//        background-color:#fff;
//        padding:0 5px 0 5px;
//    }




//.text-field {
//        position: relative;
//        margin: 10px 2.5px 20px 2.5px;
//    }
//
//input {
//        display: inline-block;
//        border: thin solid #fafafa;
//        border-bottom: solid medium #999;
//        color: #444;
//        background-color: #fafafa;
//        padding: 10px 10px 10px 10px;
//        border-top-left-radius: 10px;
//        border-top-right-radius: 10px;
//    }
//
//    input:focus {
//            border: thin solid #32cd32;
//            border-bottom: solid medium #32cd32;
//            background-color:#fff;
//        }
//
//label {
//        color: #999;
//        position: absolute;
//        pointer-events: none;
//        left: 10px;
//        top: 10px;
//        transition: 0.2s;
//    }
//
//input:focus ~ label, input:valid ~ label {
//        top: -10px;
//        left: 15px;
//        font-size: small;
//        color: #32cd32;
//        background-color:#fff;
//        padding:0 5px 0 5px;
//    }

/* VERSION 1

.text-field {
        position: relative;
        margin: 10px 0px 14px 0px;
    }

input {
        display: inline-block;
        //border: thin solid #fafafa;
        //border-bottom: solid 1px $ServexGray;
        //border-top: solid 0px $ServexMainColorOpposite;
        //border-right: solid 0px $ServexMainColorOpposite;
        //border-left: solid 0px $ServexMainColorOpposite;
        border: solid thin $ServexGray;
        color: $ServexBlue;
        background-color: white;// rgb(245, 245, 245);
        padding: 10px 10px 10px 10px;
        border-radius: 3px;
    }

    input:focus {
            //border: thin solid rgb(0,106,255);
            border-bottom: 1px solid $MainColor;
            //border-bottom: solid thin rgb(0,106,255);
            background-color: $ServexMainColorOpposite;
        }

label {
        //border-bottom: solid 1px $ServexBlue;
        font-size: 10px; //small;
        position: absolute;
        pointer-events: none;
        top: -10px;
        left: 15px;
        //background-color: $ServexMainColorOpposite;
        //background-color: $ServexBlue;
        //color: white;
        color: $MainColor;
        background-color:$ServexMainColorOpposite;
        padding:0 5px 0 5px;
        transition: 0.2s;
        border-radius: 10px;
    }

input:focus ~ label {
        top: -10px;
        left: 15px;
        font-size: 10px; //small;
        color: $MainColor;
        background-color:$ServexMainColorOpposite;
        //background-color: $ServexBlue;
        //color: white;
        border-radius: 10px;
        padding:0 15px 0 15px;
    }


*/


</style>